import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { TranslatePipe } from '../../../../../shared/pipes/translate.pipe';

@Component({
  selector: 'app-datetime-field',
  imports: [ReactiveFormsModule, FormlyModule, TranslatePipe],
  templateUrl: './datetime-field.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './datetime-field.component.css',
})
export class DateTimeFieldComponent extends FieldType<FieldTypeConfig> {}
